/**
 * usePortfolioIntensityTiles — fetch the Phase 4b portfolio-aggregate
 * intensity-tile manifest for a customer.
 *
 * Returns null (not an error) when the backend responds 404 — no
 * aggregate has been built for this customer yet; caller should fall
 * back to per-project layers or hide the heatmap toggle.
 */

import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../auth/AuthProvider";
import type { IntensityTileResponse } from "../../model/domain/types";
import { getPortfolioIntensityTiles } from "../api/portfolio";

export function usePortfolioIntensityTiles(
  customerId: string | undefined,
  enabled = true,
) {
  const { token } = useAuth();
  return useQuery<IntensityTileResponse | null>({
    queryKey: ["portfolio-intensity-tiles", customerId ?? "self"],
    queryFn: () => getPortfolioIntensityTiles(token!, customerId),
    enabled: Boolean(token) && enabled,
    staleTime: 60 * 60_000,
    gcTime: 2 * 60 * 60_000,
    retry: 0,
  });
}
